import BaseListPresenter from "../../base/BaseListPresenter";

class MyCalendarHrPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async getAllEvents() {
    const collection = "hrCalendar";
    try {
      console.log("Fetching events from collection:", collection);

      const query = {};

      const events = await this.findObjectUseCase.execute(collection, query);

      // Ensure all events have a startDate
      const eventMap = {};
      events.forEach((event) => {
        if (!event.startDate) {
          console.warn("Event missing startDate:", event);
          return; // Skip events without a valid date
        }

        const eventDate = new Date(event.startDate);
        const dateKey = `${eventDate.getFullYear()}-${
          eventDate.getMonth() + 1
        }-${eventDate.getDate()}`;

        if (!eventMap[dateKey]) {
          eventMap[dateKey] = [];
        }

        eventMap[dateKey].push({
          ...event,
          endDate: event.endDate || event.startDate, // Default endDate to startDate if not provided
          startTime: event.startTime || "00:00",
          endTime: event.endTime || "23:59",
        });
      });

      return eventMap;
    } catch (error) {
      console.error("Error fetching events:", error);
      return {};
    }
  }

  async handleSubmit(eventData) {
    const collection = "hrCalendar";

    if (!eventData || !eventData.description) {
      console.error("Invalid event data:", eventData);
      return;
    }

    // Ensure an ID exists
    if (!eventData.id) {
      eventData.id = new Date().getTime();
    }

    try {
      await this.upsertUseCase.execute(collection, eventData);
      this.view.successModal("Event has been successfully saved.");
    } catch (error) {
      console.error("Error in upsertUseCase:", error);
    }
  }

  async deleteEvent(eventId) {
    const collection = "hrCalendar";

    if (!eventId) {
      console.error("Missing event ID for deletion");
      return;
    }

    try {
      console.log("Deleting event with ID:", eventId);
      await this.deleteObjectUseCase.execute(collection, eventId);
      console.log("Event deleted successfully.");
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  }

  onClickView(eventDetails) {
    // Just view the details, no navigation to another page needed
    console.log("Viewing event details:", eventDetails);
    // You could show a modal with the event details here
  }

  onChangeReference(value, schema) {
    console.log("Reference search value:", value);
    this.reset();
    this.filter = {
      description: { $regex: value, $options: "i" }, // Search by description instead
    };
    this.getObjects();
  }
}

export default MyCalendarHrPagePresenter;
